import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import VueMaterialAdapter from 'vue-material-adapter'

const app = createApp(App)

app.use(store).use(router).use(VueCookies).use(VueMaterialAdapter).mount('#app')
